import API from '@/api'
import snack from '@/helpers/snack'
import { ROOT_QUESTION_PARENT_ID } from '@/pages/CommunicationsCenter/Tickets/CONST_TICKETS'

export default {
  async getQuestions({ commit }, payload) {
    try {
      commit('clearQuestionTicketState')

      const { data } = await API.tickets.getQuestions(payload)
      const [{ previous }] = data
      const prevParentId = previous ? previous.parent_id : ROOT_QUESTION_PARENT_ID

      commit('setParentQuestionId', prevParentId)
      commit('setQuestions', data)
    } catch {
      snack.add('Ошибка загрузки вопросов')
    }
  },
  async getUnapprovedTickets(context) {
    try {
      const { data } = await API.tickets.getUnapprovedTickets()

      return data
    } catch {
      snack.add('Ошибка получения обращений')
    }
  },
  async getTicketForm({ commit }, formId) {
    try {
      const { data } = await API.tickets.getForm({ id: formId })

      commit('clearQuestionTicketState')
      commit('setParentQuestionId', null)
      commit('setTicketFormByQuestions', data)
    } catch {
      snack.add('Ошибка получения формы обращения')
    }
  },
  async submitTicketForm({ commit }, payload) {
    try {
      const {
        data: { id },
      } = await API.tickets.submitForm(payload)

      commit('clearQuestionTicketState')

      snack.add('Обращение успешно создано', 'primary')

      return id
    } catch {
      snack.add('Ошибка сохранения формы')
    }
  },
  async sendTicketComment(context, payload) {
    try {
      await API.tickets.sendTicketComment(payload)

      snack.add('Комментарий успешно отправлен', 'primary')
    } catch {
      snack.add('Ошибка отправления')
    }
  },
  async getQuestionsSections({ commit }) {
    const { data } = await API.tickets.getQuestionsSections()

    commit('setQuestionsSections', data)
  },
}
